import { pathOr } from '@xingternal/malt-util';

export const xingIdSelector = ({ xingId }) => xingId;
export const hasUserSelector = ({ hasUser }) => hasUser;
export const activeItemSelector = ({ activeItem }) => activeItem;
export const hasOpenedSidebarSelector = ({ hasOpenedSidebar }) =>
  hasOpenedSidebar;
export const notificationsSelector = ({ notifications }) => notifications;
export const toggleSidebarSelector = ({ toggleSidebar }) => toggleSidebar;

// Features
export const featuresSelector = ({ features }) => features;
export const featuresIsPremiumSelector = ({ features }) =>
  pathOr(false, ['isPremium'], features);
export const featuresIsProJobsSelector = ({ features }) =>
  pathOr(false, ['hasProJobsMembership'], features);
export const featuresIsProBusinessSelector = ({ features }) =>
  pathOr(false, ['showProbusinessInNavigation'], features);
export const featuresIsExecutiveSelector = ({ features }) =>
  pathOr(false, ['isExecutive'], features);
export const featuresIsCampusNormalPositionSelector = ({ features }) =>
  pathOr(false, ['isCampusNormalPosition'], features);
export const featuresIsCampusProminentPositionSelector = ({ features }) =>
  pathOr(false, ['isCampusProminentPosition'], features);
export const featuresIsBrandManageEditorSelector = ({ features }) =>
  pathOr(false, ['isBrandManagerEditor'], features);

//  hasProJobsMembership
export const featuresHasCoachProfileSelector = ({ features }) =>
  pathOr(false, ['hasCoachProfile'], features);
export const featuresIsCraUserSelector = ({ features }) =>
  pathOr(false, ['isCraUser'], features);
export const featuresIsSeatManagerAdminSelector = ({ features }) =>
  pathOr(false, ['isSeatManagerAdmin'], features);
export const featuresIsJobsPosterSelector = ({ features }) =>
  pathOr(false, ['isJobsPoster'], features);
export const featuresIsBrandPageCollaboratorSelector = ({ features }) =>
  pathOr(false, ['isBrandPageCollaborator'], features);
export const featuresIsAdmasterUserSelector = ({ features }) =>
  pathOr(false, ['isAdmasterUser'], features);

export default {
  hasUserSelector,
  activeItemSelector,
  hasOpenedSidebarSelector,
  toggleSidebarSelector,
  featuresIsPremiumSelector,
  featuresIsProJobsSelector,
  featuresIsProBusinessSelector,
  featuresIsExecutiveSelector,
  featuresIsCampusNormalPositionSelector,
  featuresIsCampusProminentPositionSelector,
};
